
export const setEmailBodyExpocienciasPagoEst = (props, urlFile) => {

    const styles = {
        p:{border:'1px solid gray', width:'380px', backgroundColor:'#ddd'},
        div:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#ddd'},
        divWhite:{textAlign:'center', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
        divWhiteLeft:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
        divWhiteLeftNoBorder:{width:'380px', padding:'10px 20px', margin:'10px 0',backgroundColor:'#fff'},
        li:{padding:'6px 0'},
    }

    // let facturaValue = '';
    // if (props.requiereFactura) {
    //     facturaValue = 
    //     <p>
    //         Facturación: <strong>SI requiere factura</strong><br /><br />
    //         Nombre a facturar: {props.factNombre}<br />
    //         RFC: {props.factRfc}<br />
    //         C.P.: {props.factCP}<br />
    //         Uso CFDI (clave): {props.factUsoCFDI}<br />
    //         Regimen fiscal (clave): {props.factRegimenFiscal}<br />
    //     </p>;
    // } else {
    //     facturaValue = <p>Facturación: <strong>NO requiere factura</strong></p>;
    // }
    

    return (
        <>
            <div style={styles.divWhite}>
                <img src="https://eventos.cibnor.mx/registro/expociencias/img/logo_expociencias2022.png" alt="logo" width={380}></img>
            </div>
            <div style={styles.divWhite}>
                <p>¡Su comprobante ha sido recibido con éxito!</p>
                <h2>Numero de referencia: <br />{props.refBancaria}</h2>
            </div>
            <div style={styles.div}>
                <h4>Asesoría</h4>
                <p> 
                    Nombre completo: {props.asesorNombres} {props.asesorApellidos}<br />
                    Correo: {props.asesorCorreo}<br />
                </p>
            </div>
            {/* <div style={styles.div}>
                {facturaValue}
            </div> */}
            <div style={styles.divWhiteLeft}>
                <h3>
                    <a href={urlFile}>
                        <strong>Enlace para consultar el comprobante de pago ingresado</strong>.
                    </a>
                </h3>
            </div>
            <div style={styles.divWhiteLeftNoBorder}>
               <strong><i>Atentamente,<br/>Comité organizador</i></strong>
            </div>
        </>
        
    );
};

